import React, { useEffect, useState, useRef } from "react";
import styles from "../servicecard/Servicecard.module.css";
import { motion } from "framer-motion";
import { cardVariants } from "../../controller/Cardinfo";

const Servicecard = ({
  data = [],
  heading,
  subheading,
  sliceEndNum,
  image,
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [maxHeight, setMaxHeight] = useState(0);
  const cardRefs = useRef([]);

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth < 768);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  // Calculate max height dynamically after rendering
  useEffect(() => {
    if (!isMobile && cardRefs.current.length) {
      const heights = cardRefs.current.map((card) => card?.offsetHeight || 0);
      const tallest = Math.max(...heights);
      setMaxHeight(tallest);
    } else {
      setMaxHeight("auto"); // reset for mobile
    }
  }, [isMobile, data, sliceEndNum]);

  const renderCardContent = (item) => (
    <>
      <div className={styles.hoverCircle}></div>
      <div className={styles.whiteCircle}></div>
      <div className={styles.titleRow}>
        <span className={`${styles.legendIcon} ${styles.hoverContent}`}>
          {typeof item.icon === "string" && item.icon.startsWith("fa") ? (
            <i className={item.icon}></i>
          ) : (
            <img
              src={item.icon}
              alt={item.title}
              className={styles.serviceIcon}
            />
          )}
        </span>

        {item.title && (
          <h5
            className={`${styles.cardTitle} ${styles.hoverContent}`}
          >
            {item.title}
          </h5>
        )}
      </div>

      {item.description && (
        <p
          className={`main_paragraph ${styles.cardText} ${styles.hoverContent}`}
        >
          {item.description}
        </p>
      )}

      {item.subtitle && (
        <h5 className={`${styles.cardSubTitle} ${styles.hoverContent}`}>
          {item.subtitle}
        </h5>
      )}

      {item.subdescription &&
        Array.isArray(item.subdescription) &&
        item.subdescription.length > 0 && (
          <ul className={`${styles.subDescList} ${styles.hoverContent}`}>
            {item.subdescription.map((point, idx) => (
              <li key={idx}>
                <p className="main_paragraph mb-0">{point}</p>
              </li>
            ))}
          </ul>
        )}
    </>
  );

  const cardsToRender = sliceEndNum ? data.slice(0, sliceEndNum) : data;

  return (
    <div className={`container-fluid custom-space ${styles.Servicebody}`}>
      <div className="row">
        {heading && (
          <div className="text-center">
            <h2
              className={`main_heading custom-space ${styles.service_heading}`}
            >
              {heading}
            </h2>
            <p className={`main_subheading ${styles.service_subheading} p-0`}>
              {subheading}
            </p>
            {image && (
              <div className={styles.serviceBanner}>
                <img
                  src={image}
                  alt="Service banner"
                  className={styles.bannerImage}
                />
              </div>
            )}
          </div>
        )}
        {isMobile ? (
          <div className="row mt-2">
            {cardsToRender.map((item, index) => (
              <div className="col-md-4 mb-4" key={index}>
                <div className={styles.hoverCard}>
                  {renderCardContent(item)}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <motion.div
            className="row mt-2 p-0"
            initial="hidden"
            whileInView="visible"
            // viewport={{ once: true, amount: 0.3 }}
          >
            {cardsToRender.map((item, index) => (
              <div className="col-md-6 mb-4" key={index}>
                <motion.div
                  className={styles.hoverCard}
                  variants={cardVariants}
                  ref={(el) => (cardRefs.current[index] = el)}
                  style={{ minHeight: maxHeight }}
                >
                  {renderCardContent(item)}
                </motion.div>
              </div>
            ))}
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default Servicecard;
